/* smart-answer-card-consolidated.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./smart-answer-card-consolidated.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl-next';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { cx } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import { SmartCardProvider } from '@atlaskit/link-provider';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import UFOCustomCohortData from '@atlaskit/react-ufo/custom-cohort-data';
import UFOCustomData from '@atlaskit/react-ufo/custom-data';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import UFOSegment from '@atlaskit/react-ufo/segment';
import { AnimatedWrapper } from '@atlassian/ai-common';
import { getFrontendExperiment } from '@atlassian/search-experiment';
import { AIAnswerError } from '../../ai-answer-dialog/ai-answer-body/ai-answer-result/ai-answer-error';
import { useAIAnswerContext } from '../../ai-answer-dialog/ai-answer-context';
import { SmartAnswerFooterSection } from '../../ai-answer-dialog/ai-answer-footer/ai-answer-footer';
import { aiAnswerCollapseClicked, aiAnswerExpandClicked, getSmartLinksAnalyticsContextData, onAIAnswerResultCompleteShown, onAIAnswerResultFirstByteShown, onAIAnswerSourceClick, onAIAnswerTabClick, SmartLinksAnalyticsContextLocation } from '../../ai-answer-dialog/analytics';
import { SainAction, useSAINUsageCriteriaMet } from '../../common/controller/analytics/hooks/use-sain-usage';
import { useAnalytics } from '../../common/controller/analytics/use-analytics';
import { AISourcesCarousel } from '../../common/ui/ai-sources';
import { getSAINLayerFrontendMutiArmExperiment } from '../../common/utils/get-sain-layer-frontend-experiment';
import { AIAnswerTab, aiAnswerTabsOrder, QueryIntent } from '../../constants';
import { isHello } from '../../utils';
import { useBufferedContent } from '../common/hooks/use-buffered-content';
import { useContentTruncationDetector } from '../common/hooks/use-content-truncation-detector';
import { useDelayedResizeObserver } from '../common/hooks/use-delayed-resize-observer';
import { AICollapse } from '../common/ui/ai-collapse';
import { AIDisclaimerAndFeedback } from '../common/ui/ai-disclaimer-and-feedback';
import { AITabs } from '../common/ui/ai-tabs';
import { AITabsHeader, AITabsHeaderWithSourcesStack } from '../common/ui/ai-tabs-header';
import { AITabsPanel } from '../common/ui/ai-tabs-panel';
import { AITabsSources } from '../common/ui/ai-tabs-sources';
import { ReactRenderer } from '../common/ui/react-renderer';
import { ReadMoreButton } from '../common/ui/read-more-button';
import { SmartAnswerCardBodyGenerating } from '../common/ui/smart-answer-card-body-generating';
import { messages } from './messages';

// Memoized renderer component outside main component
var MemoizedRenderer = /*#__PURE__*/React.memo(function MemoizedRenderer(_ref) {
  var contentToRender = _ref.contentToRender,
    showAnimation = _ref.showAnimation;
  return /*#__PURE__*/React.createElement(ReactRenderer, {
    key: "stable-renderer",
    markdown: contentToRender,
    animateComponents: showAnimation
  });
});
var styles = {
  fullWidth: "_1bsbauwl _p12f1osq",
  container: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x",
  interactive: "_80omtlke",
  root: "_1tkebn52",
  explicitQuestion: "_1tke1edt",
  fullHeight: "_4t3i1osq",
  disclaimer: "_n3tdutpp _19bvpxbi _u5f3pxbi _ca0q1b66",
  sectionContainer: "_n3tdutpp _19bvpxbi _u5f3pxbi _ca0q1b66"
};
function SmartAnswerCardConsolidatedComponent(_ref2) {
  var _partialResponse$part;
  var onFMPReached = _ref2.onFMPReached,
    onAnswerExpandedChange = _ref2.onAnswerExpandedChange,
    queryIntent = _ref2.queryIntent;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var containerRef = useRef(null);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    didUserTriggerCollapse = _useState4[0],
    setDidUserTriggerCollapse = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isVisibleTextComplete = _useState6[0],
    setIsVisibleTextComplete = _useState6[1];
  var _useState7 = useState(AIAnswerTab.AI_ANSWER),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedTab = _useState8[0],
    setSelectedTab = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showAnimation = _useState0[0],
    setShowAnimation = _useState0[1];
  var componentRenderTimeRef = useRef(Date.now());
  var firstByteEventFiredRef = useRef(false);
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    hasError = _useAIAnswerContext.hasError,
    isAnswered = _useAIAnswerContext.isAnswered,
    loading = _useAIAnswerContext.loading,
    partialResponse = _useAIAnswerContext.partialResponse;
  var cloudId = commonAttributes.cloudId,
    queryHash = commonAttributes.queryHash,
    searchSessionId = commonAttributes.searchSessionId,
    answerString = commonAttributes.answerString,
    sources = commonAttributes.sources,
    errorStateSuggestedQueries = commonAttributes.errorStateSuggestedQueries;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var streamingText = (_partialResponse$part = partialResponse === null || partialResponse === void 0 ? void 0 : partialResponse.partialNlpResult) !== null && _partialResponse$part !== void 0 ? _partialResponse$part : '';
  var _useState1 = useState(streamingText),
    _useState10 = _slicedToArray(_useState1, 2),
    streamingTextToDisplay = _useState10[0],
    setStreamingTextToDisplay = _useState10[1];
  var isNewSainLoadingEnabled = fg('kd_sain_rovo_loading');
  var onHello = isHello(cloudId);

  // Refs for content truncation detection
  var isVisibleTextCompleteRef = useRef(false);
  var completeAnswerAnalyticsEventFiredRef = useRef(false);
  var renderedContentRef = useRef(null);
  var contentContainerRef = useRef(null);
  useEffect(function () {
    if (collapsed && !isVisibleTextComplete) {
      setStreamingTextToDisplay(streamingText);
    } else if (!collapsed) {
      setStreamingTextToDisplay(streamingText);
    }
  }, [collapsed, isVisibleTextComplete, streamingText]);

  // Notify context when collapsed state changes
  useEffect(function () {
    onAnswerExpandedChange === null || onAnswerExpandedChange === void 0 || onAnswerExpandedChange(!collapsed);
  }, [collapsed, onAnswerExpandedChange]);
  useEffect(function () {
    if (!loading && !hasError && !isVisibleTextComplete) {
      setIsVisibleTextComplete(true);
      onFMPReached === null || onFMPReached === void 0 || onFMPReached(); // Mark FMP as reached for cached answers
    }
  }, [loading, hasError, isVisibleTextComplete, onFMPReached]);

  // Track if we should show animations (if loading or partialResponse are true)
  useEffect(function () {
    if (!showAnimation && loading && partialResponse) {
      setShowAnimation(true);
    }
  }, [loading, partialResponse, showAnimation]); // use useEffect to trigger analytics event in order to avoid needing to
  // pass commonAttributes as a dependency to handleExpandCollapseButtonClick
  // and thus avoid re-rendering SmartAnswerCardBodyStreaming with every
  // update to commonAttributes (which gets updated with the streamed text)
  useEffect(function () {
    if (didUserTriggerCollapse) {
      fireAnalyticsEvent(aiAnswerCollapseClicked(commonAttributes));
    }
  }, [didUserTriggerCollapse, commonAttributes, fireAnalyticsEvent]);

  // Detect if content is truncated when collapsed
  var isContentTruncated = useContentTruncationDetector(renderedContentRef, contentContainerRef, collapsed);

  // Complete answer analytics
  useEffect(function () {
    var _contentContainerRef$, _contentContainerRef$2;
    // Only fire once and ensure DOM element is ready with meaningful content
    if (completeAnswerAnalyticsEventFiredRef.current || !renderedContentRef.current) {
      return;
    }
    var answerHeight = renderedContentRef.current.getBoundingClientRect().height;
    var containerHeight = (_contentContainerRef$ = (_contentContainerRef$2 = contentContainerRef.current) === null || _contentContainerRef$2 === void 0 ? void 0 : _contentContainerRef$2.getBoundingClientRect().height) !== null && _contentContainerRef$ !== void 0 ? _contentContainerRef$ : 0;
    var whitespaceHeight = Math.max(containerHeight - answerHeight, 0);

    // Only fire if we have meaningful height (content is rendered)
    if (answerHeight > 0 && containerHeight > 0) {
      fireAnalyticsEvent(onAIAnswerResultCompleteShown(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        answerHeight: answerHeight,
        containerHeight: containerHeight,
        whitespaceHeight: whitespaceHeight,
        queryIntent: queryIntent
      })));
      completeAnswerAnalyticsEventFiredRef.current = true;
    }
  }, [fireAnalyticsEvent, commonAttributes, queryIntent, isContentTruncated]);

  // SAIN usage event
  useEffect(function () {
    fireSAINUsageEvent({
      commonAttributes: commonAttributes
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var handleExpandCollapseButtonClick = useCallback(function () {
    if (collapsed) {
      setCollapsed(false);
      setDidUserTriggerCollapse(false);
    } else {
      setCollapsed(true);
      setDidUserTriggerCollapse(true);
    }
  }, [collapsed]);
  var handleVisibleTextComplete = useCallback(function () {
    setIsVisibleTextComplete(true);
    onFMPReached === null || onFMPReached === void 0 || onFMPReached(); // Mark FMP as reached for streaming answers
  }, [onFMPReached]);
  var handleContainerClick = useCallback(function (event) {
    var _window$getSelection$, _window$getSelection, _containerRef$current, _containerRef$current2;
    var selection = (_window$getSelection$ = (_window$getSelection = window.getSelection()) === null || _window$getSelection === void 0 ? void 0 : _window$getSelection.toString()) !== null && _window$getSelection$ !== void 0 ? _window$getSelection$ : '';
    // Highlighting text should not expand the card
    var hasHighlightedText = selection.length > 0;
    // Clicking in a feedback modal or flag should not expand the card
    var isClickingOnContainer = (_containerRef$current = (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.contains(event.target)) !== null && _containerRef$current !== void 0 ? _containerRef$current : false;
    if (collapsed && !hasHighlightedText && isClickingOnContainer) {
      setCollapsed(false);
      fireAnalyticsEvent(aiAnswerExpandClicked(commonAttributes));
      fireSAINUsageEvent({
        metCriteria: SainAction.EXPAND_CLICKED,
        commonAttributes: commonAttributes
      });
    }
  }, [collapsed, fireAnalyticsEvent, commonAttributes, fireSAINUsageEvent]);
  var handleTabChange = useCallback(function (selectedTabIndex) {
    var selectedTab = aiAnswerTabsOrder[selectedTabIndex];
    setSelectedTab(selectedTab);
    fireAnalyticsEvent(onAIAnswerTabClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      selectedTab: selectedTab
    })));
  }, [setSelectedTab, fireAnalyticsEvent, commonAttributes]);
  var sourceClickCallback = useCallback(function (index, source, hostname) {
    fireAnalyticsEvent(onAIAnswerSourceClick(_objectSpread({
      sourceIndex: index,
      hostname: hostname,
      sourceProduct: source.product || ''
    }, commonAttributes)));
    fireSAINUsageEvent({
      metCriteria: SainAction.SOURCE_CLICKED,
      commonAttributes: commonAttributes,
      sourceProduct: source.product || ''
    });
  }, [fireAnalyticsEvent, commonAttributes, fireSAINUsageEvent]);

  // UFO resize observer for streaming
  var resizeObserverCallback = useCallback(function () {
    if (!isVisibleTextCompleteRef.current && renderedContentRef.current && contentContainerRef.current && !!streamingTextToDisplay) {
      var renderedContentRefHeight = renderedContentRef.current.getBoundingClientRect().height;
      var contentContainerRefHeight = contentContainerRef.current.getBoundingClientRect().height;
      var _isVisibleTextComplete = renderedContentRefHeight > contentContainerRefHeight;
      if (_isVisibleTextComplete) {
        handleVisibleTextComplete();
        isVisibleTextCompleteRef.current = true;
      }
    }
  }, [handleVisibleTextComplete, streamingTextToDisplay]);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  useDelayedResizeObserver(renderedContentRef, resizeObserverCallback, 100, [streamingTextToDisplay]);
  var bufferedContent = useBufferedContent(streamingTextToDisplay, isAnswered && !loading);
  useEffect(function () {
    if (bufferedContent.length > 0 && !firstByteEventFiredRef.current) {
      fireAnalyticsEvent(onAIAnswerResultFirstByteShown(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        timeToFirstByte: Date.now() - componentRenderTimeRef.current
      })));
      firstByteEventFiredRef.current = true;
    }
  }, [bufferedContent, commonAttributes, fireAnalyticsEvent]);

  // Use answerString when complete, bufferedContent when streaming
  var contentToRender = isAnswered ? answerString : bufferedContent;

  // Experiments
  var _getFrontendExperimen = getFrontendExperiment({
      abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    }),
    serveErrorStateSuggestedQueriesExp = _getFrontendExperimen.serveExperiment;
  var _getSAINLayerFrontend = getSAINLayerFrontendMutiArmExperiment({
      abTestId: 'kd_sain_sources_redesign_pt_2'
    }),
    cohortSourcesRedesignExperimentPt2 = _getSAINLayerFrontend.cohort;
  var showReadMoreButton = collapsed && isContentTruncated;

  // Single return statement with React component for main content
  var isStreaming = !isAnswered && (loading || loading === undefined);

  // Early return for error state
  if (hasError) {
    return /*#__PURE__*/React.createElement(Box, {
      xcss: styles.fullWidth
    }, /*#__PURE__*/React.createElement(AIAnswerError, null));
  }

  // Early return for generating state
  if (!isAnswered && (loading || loading === undefined)) {
    if (!partialResponse || bufferedContent.length < 1) {
      return /*#__PURE__*/React.createElement(Box, {
        xcss: styles.fullWidth
      }, /*#__PURE__*/React.createElement(UFOSegment, {
        name: "search-ai-dialog-all-text"
      }, /*#__PURE__*/React.createElement(UFOLoadHold, {
        name: "search-ai-dialog-all-text-loading",
        hold: true
      }), /*#__PURE__*/React.createElement(UFOSegment, {
        name: "search-ai-dialog-visible-text"
      }, /*#__PURE__*/React.createElement(UFOLoadHold, {
        name: "search-ai-dialog-visible-text-loading",
        hold: true
      }), /*#__PURE__*/React.createElement(AnimatedWrapper, null, /*#__PURE__*/React.createElement(SmartAnswerCardBodyGenerating, {
        queryIntent: queryIntent
      })))));
    }
  }
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.fullWidth
  }, /*#__PURE__*/React.createElement(UFOSegment, {
    name: "search-ai-dialog-all-text"
  }, /*#__PURE__*/React.createElement(UFOLoadHold, {
    name: "search-ai-dialog-all-text-loading",
    hold: loading
  }), /*#__PURE__*/React.createElement(UFOSegment, {
    name: "search-ai-dialog-visible-text"
  }, /*#__PURE__*/React.createElement(UFOLoadHold, {
    name: "search-ai-dialog-visible-text-loading",
    hold: !isVisibleTextComplete
  }), fg('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UFOCustomCohortData, {
    dataKey: "queryHash",
    value: queryHash
  }), /*#__PURE__*/React.createElement(UFOCustomCohortData, {
    dataKey: "searchSessionId",
    value: searchSessionId
  }), /*#__PURE__*/React.createElement(UFOCustomCohortData, {
    dataKey: "queryIntent",
    value: queryIntent
  })) : /*#__PURE__*/React.createElement(UFOCustomData, {
    data: {
      queryHash: queryHash,
      searchSessionId: searchSessionId,
      queryIntent: queryIntent
    }
  }), isNewSainLoadingEnabled ? /*#__PURE__*/React.createElement(AnimatedWrapper, {
    isAnswerComplete: isAnswered && !loading
  }, /*#__PURE__*/React.createElement(SmartAnswerCardContent, {
    isStreaming: isStreaming,
    collapsed: collapsed,
    queryIntent: queryIntent,
    showReadMoreButton: showReadMoreButton,
    onHello: onHello,
    cohortSourcesRedesignExperimentPt2: cohortSourcesRedesignExperimentPt2,
    handleExpandCollapseButtonClick: handleExpandCollapseButtonClick,
    contentContainerRef: contentContainerRef,
    renderedContentRef: renderedContentRef,
    handleTabChange: handleTabChange,
    selectedTab: selectedTab,
    sources: sources,
    searchSessionId: searchSessionId,
    sourceClickCallback: sourceClickCallback,
    errorStateSuggestedQueries: errorStateSuggestedQueries,
    serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp,
    commonAttributes: commonAttributes,
    contentToRender: contentToRender,
    showAnimation: showAnimation,
    handleContainerClick: handleContainerClick,
    containerRef: containerRef,
    isNewSainLoadingEnabled: isNewSainLoadingEnabled
  })) : /*#__PURE__*/React.createElement(SmartAnswerCardContent, {
    isStreaming: isStreaming,
    collapsed: collapsed,
    queryIntent: queryIntent,
    showReadMoreButton: showReadMoreButton,
    onHello: onHello,
    cohortSourcesRedesignExperimentPt2: cohortSourcesRedesignExperimentPt2,
    handleExpandCollapseButtonClick: handleExpandCollapseButtonClick,
    contentToRender: contentToRender,
    showAnimation: showAnimation,
    contentContainerRef: contentContainerRef,
    renderedContentRef: renderedContentRef,
    handleTabChange: handleTabChange,
    selectedTab: selectedTab,
    sources: sources,
    searchSessionId: searchSessionId,
    sourceClickCallback: sourceClickCallback,
    errorStateSuggestedQueries: errorStateSuggestedQueries,
    serveErrorStateSuggestedQueriesExp: serveErrorStateSuggestedQueriesExp,
    commonAttributes: commonAttributes,
    handleContainerClick: handleContainerClick,
    containerRef: containerRef,
    isNewSainLoadingEnabled: isNewSainLoadingEnabled
  }))));
}
function SmartAnswerCardContent(_ref3) {
  var isStreaming = _ref3.isStreaming,
    collapsed = _ref3.collapsed,
    queryIntent = _ref3.queryIntent,
    showReadMoreButton = _ref3.showReadMoreButton,
    onHello = _ref3.onHello,
    cohortSourcesRedesignExperimentPt2 = _ref3.cohortSourcesRedesignExperimentPt2,
    handleExpandCollapseButtonClick = _ref3.handleExpandCollapseButtonClick,
    contentContainerRef = _ref3.contentContainerRef,
    renderedContentRef = _ref3.renderedContentRef,
    handleTabChange = _ref3.handleTabChange,
    selectedTab = _ref3.selectedTab,
    sources = _ref3.sources,
    searchSessionId = _ref3.searchSessionId,
    sourceClickCallback = _ref3.sourceClickCallback,
    errorStateSuggestedQueries = _ref3.errorStateSuggestedQueries,
    serveErrorStateSuggestedQueriesExp = _ref3.serveErrorStateSuggestedQueriesExp,
    commonAttributes = _ref3.commonAttributes,
    contentToRender = _ref3.contentToRender,
    showAnimation = _ref3.showAnimation,
    handleContainerClick = _ref3.handleContainerClick,
    containerRef = _ref3.containerRef,
    isNewSainLoadingEnabled = _ref3.isNewSainLoadingEnabled;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(!isNewSainLoadingEnabled && !isStreaming ? styles.container : undefined, collapsed ? styles.interactive : undefined),
    onClick: handleContainerClick,
    ref: containerRef
  }, /*#__PURE__*/React.createElement(Stack, {
    alignBlock: "stretch",
    grow: "fill",
    spread: "space-between",
    xcss: cx(isStreaming ? styles.root : styles.fullHeight, queryIntent === QueryIntent.EXPLICIT_QUESTION && styles.explicitQuestion)
  }, /*#__PURE__*/React.createElement(Stack, {
    alignBlock: "stretch",
    grow: "fill",
    spread: "space-between",
    xcss: styles.fullHeight
  }, /*#__PURE__*/React.createElement(Box, null, onHello || cohortSourcesRedesignExperimentPt2 === 'sources_under_answer' ? /*#__PURE__*/React.createElement(AICollapse, {
    title: /*#__PURE__*/React.createElement(Heading, {
      as: "h2",
      size: "xxsmall"
    }, /*#__PURE__*/React.createElement(Text, {
      color: "color.text.subtlest",
      size: "small",
      weight: "bold"
    }, /*#__PURE__*/React.createElement(FormattedMessage, messages.smart_answer_card_title))),
    isCollapsed: collapsed,
    onExpandCollapse: handleExpandCollapseButtonClick,
    ref: contentContainerRef,
    showReadMoreButton: showReadMoreButton,
    queryIntent: queryIntent
  }, /*#__PURE__*/React.createElement(Box, {
    ref: renderedContentRef,
    testId: "sain-fmp-target"
  }, /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: getSmartLinksAnalyticsContextData({
      location: SmartLinksAnalyticsContextLocation.SAIN_Q_AND_A_CARD,
      commonAttributes: commonAttributes
    })
  }, /*#__PURE__*/React.createElement(SmartCardProvider, null, /*#__PURE__*/React.createElement(MemoizedRenderer, {
    contentToRender: contentToRender,
    showAnimation: showAnimation
  }))))) : /*#__PURE__*/React.createElement(AITabs, {
    onChange: isStreaming ? undefined : handleTabChange,
    selectedTabIndex: isStreaming ? undefined : aiAnswerTabsOrder.indexOf(selectedTab)
  }, cohortSourcesRedesignExperimentPt2 === 'sources_tab_redesign' ? /*#__PURE__*/React.createElement(AITabsHeaderWithSourcesStack, {
    collapsed: collapsed,
    onExpandCollapseButtonClick: handleExpandCollapseButtonClick,
    sources: sources
  }) : /*#__PURE__*/React.createElement(AITabsHeader, {
    collapsed: collapsed,
    onExpandCollapseButtonClick: handleExpandCollapseButtonClick,
    showSourcesTab: sources.length > 0
  }), /*#__PURE__*/React.createElement(AITabsPanel, {
    collapsed: collapsed,
    ref: contentContainerRef,
    showReadMoreButton: showReadMoreButton,
    queryIntent: queryIntent
  }, /*#__PURE__*/React.createElement(Box, {
    ref: renderedContentRef,
    testId: "sain-fmp-target"
  }, /*#__PURE__*/React.createElement(AnalyticsContext, {
    data: getSmartLinksAnalyticsContextData({
      location: SmartLinksAnalyticsContextLocation.SAIN_Q_AND_A_CARD,
      commonAttributes: commonAttributes
    })
  }, /*#__PURE__*/React.createElement(SmartCardProvider, null, /*#__PURE__*/React.createElement(MemoizedRenderer, {
    contentToRender: contentToRender,
    showAnimation: showAnimation
  }))))), !isStreaming && sources.length > 0 ? /*#__PURE__*/React.createElement(AITabsPanel, {
    collapsed: collapsed,
    queryIntent: queryIntent,
    showReadMoreButton: showReadMoreButton,
    ref: contentContainerRef
  }, /*#__PURE__*/React.createElement(AITabsSources, null)) : null), showReadMoreButton && /*#__PURE__*/React.createElement(ReadMoreButton, {
    onClick: handleExpandCollapseButtonClick
  })), !isStreaming && !collapsed && sources.length > 0 && (onHello || cohortSourcesRedesignExperimentPt2 === 'sources_under_answer') ? /*#__PURE__*/React.createElement(Box, {
    xcss: styles.sectionContainer
  }, /*#__PURE__*/React.createElement(AISourcesCarousel, {
    sources: sources,
    searchSessionId: searchSessionId,
    onClickHandler: sourceClickCallback
  })) : null, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.disclaimer
  }, /*#__PURE__*/React.createElement(AIDisclaimerAndFeedback, {
    showFeedbackButtons: !isStreaming,
    showCopyButton: !isStreaming,
    renderedContentRef: renderedContentRef
  }))), !isStreaming && (!collapsed || errorStateSuggestedQueries.length > 0 && serveErrorStateSuggestedQueriesExp) ? /*#__PURE__*/React.createElement(SmartAnswerFooterSection, {
    showOpenChat: true
  }) : null));
}
export function SmartAnswerCardConsolidated(_ref4) {
  var onFMPReached = _ref4.onFMPReached,
    onAnswerExpandedChange = _ref4.onAnswerExpandedChange,
    queryIntent = _ref4.queryIntent;
  return /*#__PURE__*/React.createElement(UFOSegment, {
    name: "smart-answer-card"
  }, /*#__PURE__*/React.createElement(SmartAnswerCardConsolidatedComponent, {
    onFMPReached: onFMPReached,
    onAnswerExpandedChange: onAnswerExpandedChange,
    queryIntent: queryIntent
  }));
}